import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unfold",
  "use": "icon-unfold-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 34 34\" id=\"icon-unfold\"><circle stroke=\"#989898\" r=\"16.5\" cy=\"17\" cx=\"17\" data-follow-stroke=\"#989898\" /><path stroke-linejoin=\"round\" stroke-linecap=\"round\" stroke-width=\"2\" stroke=\"#989898\" d=\"M16.333 23H11v-5.334M17.668 11h5.333v5.333\" data-follow-stroke=\"#989898\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol